import styled from 'styled-components';
import { colors, breakpoints } from 'app/variables';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${breakpoints.medium}) {
    position: absolute;
    height: 100vh;
  }

  @media (max-width: ${breakpoints.desktop}) {
    align-items: center;
  }

  @media (max-width: ${breakpoints.medium}) {
    height: inherit;
  }
`;

export const FullScreenDetails = styled.div`
  background: white;
  display: none;
  @media (min-width: ${breakpoints.desktop}) {
    display: flex;
    flex-direction: column;
  }

  overflow-y: auto;
  overflow-x: hidden;
  max-width: 100%;
  min-height: 20rem;
  padding: 10.5px;
  background: white;
  position: relative;
  border: 1px solid ${colors.pacificBlue};

  @media (min-width: ${breakpoints.mediumDesktop}) {
    margin: 0 5%;
  }

  @media (min-width: ${breakpoints.largeDesktop}) {
    margin: 0 15%;
  }
`;
export const FullScreenFlex = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0;

  @media (min-width: ${breakpoints.medium}) {
    display: flex;
    position: absolute;
    max-width: 465px;
    margin: 0 auto;
    border-radius: 10px;
  }
  @media (min-width: ${breakpoints.desktop}) {
    max-width: 465px;
    margin: 0 auto;
    border-radius: 10px;
    right: 18%;
    padding-top: 2rem;
  }

  & input:focus {
    outline: none;
  }

  @media (min-width: ${breakpoints.medium}) {
    max-height: 100%;
    flex-direction: column;
  }
`;
export const FlexWrapper = styled.div`
  background-color: ${colors.white};
  height: 100vh;
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.desktop}) {
    padding: 1rem 1rem 0 1rem;
  }
  @media (min-width: ${breakpoints.medium}) {
    border-radius: 10px;
    height: min(85vh, 44rem);

    box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.1);
  }
`;
